import { render } from "./writeMessageForClient.html?vue&type=template&id=5213777d&scoped=true&ts=true&external"
import script from "./WriteMessageForClient.vue?vue&type=script&lang=ts"
export * from "./WriteMessageForClient.vue?vue&type=script&lang=ts"

import "./WriteMessageForClient.vue?vue&type=style&index=0&id=5213777d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5213777d"]])

export default __exports__